import React from "react";
import { Box, Button, Tooltip } from "@material-ui/core";
import {
  Edit,
  Delete,
  Visibility,
  CheckCircle,
  Equalizer,
  TurnedIn,
  GroupAdd,
  EmojiEvents,
  Block,
  RateReview,
  PanTool,
  Gavel,
} from "@material-ui/icons";

// Mỗi action có icon + tooltip + class style + onClick.
// onClick set open cho modal. Một số action (ví dụ "detail") cần xử lý parent
// version (đề tài đã có phiên bản cũ), nên giữ logic cũ.
const ACTION_MAP = {
  detail:              { tooltip: "Chi tiết",                      icon: <Visibility fontSize="small" />, color: "primary" },
  edit:                { tooltip: "Chỉnh sửa",                     icon: <Edit fontSize="small" />,        color: "primary" },
  delete:              { tooltip: "Xoá",                           icon: <Delete fontSize="small" />,      className: "error-button" },
  reviewRegistration:  { tooltip: "Duyệt đăng ký",                 icon: <CheckCircle fontSize="small" />, className: "success-button" },
  conduct:             { tooltip: "Duyệt thực hiện (cấp mã)",      icon: <CheckCircle fontSize="small" />, className: "success-button" },
  reviewConduct:       { tooltip: "Yêu cầu chỉnh sửa / loại",      icon: <RateReview fontSize="small" />,  color: "secondary" },
  progress:            { tooltip: "Nộp báo cáo tiến độ",           icon: <Equalizer fontSize="small" />,   className: "success-button" },
  reviewProgress:      { tooltip: "Duyệt báo cáo tiến độ",         icon: <Gavel fontSize="small" />,       className: "success-button" },
  requestStop:         { tooltip: "Xin dừng thực hiện",            icon: <PanTool fontSize="small" />,     color: "secondary" },
  reviewStop:          { tooltip: "Duyệt đơn xin dừng",            icon: <Block fontSize="small" />,       color: "secondary" },
  acceptanceSubmit:    { tooltip: "Nộp báo cáo tổng kết",          icon: <TurnedIn fontSize="small" />,    className: "success-button" },
  councilFinal:        { tooltip: "Gán hội đồng nghiệm thu",       icon: <GroupAdd fontSize="small" />,    className: "success-button" },
  gradeDepartmentLevel: { tooltip: "Nghiệm thu cấp Khoa",          icon: <EmojiEvents fontSize="small" />, className: "success-button" },
  gradeSchoolLevel:        { tooltip: "Chấm báo cáo cấp Trường",           icon: <EmojiEvents fontSize="small" />, className: "success-button" },
  gradeNationalLevel:      { tooltip: "Cập nhật kết quả cấp Quốc gia",     icon: <EmojiEvents fontSize="small" />, className: "success-button" },
  gradeInternationalLevel: { tooltip: "Cập nhật kết quả cấp Quốc tế",      icon: <EmojiEvents fontSize="small" />, className: "success-button" },
  disabled:            { tooltip: "—",                             icon: <Visibility style={{ color: "#ffffff00" }} fontSize="small" />, color: "primary" },
};

// ActionButton — render danh sách action key thành các nút bấm.
// - Click → setOpen({ [key]: true }) + setDetail(row) → Modal tự lookup.
// - Giữ tương thích với legacy: field `parentResearch` dùng để show tên/member cũ
//   khi đề tài đã có phiên bản con (status chỉ sửa).
function ActionButton({ actions, row, setOpen, setDetail }) {
  if (!actions || actions.length === 0) return null;

  const handleClick = (key) => {
    // Với các action thuần duyệt trên hàng có versioning (parent != 0 → đề tài đã sửa),
    // hiển thị detail là parent để admin nhìn thấy version gốc, nhưng status vẫn là status mới.
    if (key === "detail") {
      const parent = row?.parentResearch;
      if (parent) {
        setDetail({ ...row, nameOld: parent?.name, parentResearch: parent });
      } else {
        setDetail({ ...row });
      }
    } else {
      setDetail({ ...row });
    }
    setOpen({ [key]: true });
  };

  // Stack dọc — mỗi nút trên 1 dòng riêng. Cột "Tác vụ" trong bảng chỉ cần đủ
  // rộng cho 1 nút, không bị tràn ngang dù có nhiều action.
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gridGap={6}
    >
      {actions.map((key, idx) => {
        const meta = ACTION_MAP[key] || ACTION_MAP.detail;
        const disabled = key === "disabled";
        const btn = (
          <Button
            variant="contained"
            color={meta.color || "primary"}
            className={meta.className}
            disabled={disabled}
            style={{
              width: 40,
              minWidth: 40,
              height: 32,
              padding: 0,
            }}
            onClick={() => !disabled && handleClick(key)}
          >
            {meta.icon}
          </Button>
        );
        return (
          <React.Fragment key={`act-${key}-${idx}`}>
            {disabled ? btn : <Tooltip title={meta.tooltip}>{btn}</Tooltip>}
          </React.Fragment>
        );
      })}
    </Box>
  );
}

export default ActionButton;
